<div class="ui-collapsible-container__content">
  <ng-content></ng-content>
</div>
@if (closeable) {
  <div class="ui-collapsible-container__close">
    <campus-button icon inline (click)="open = false">
      <campus-icon svgIcon="close"></campus-icon>
    </campus-button>
  </div>
}
